// extracted by mini-css-extract-plugin
export default {"card":"c-f_cX","card_styleDefault":"c-f_cY","card_styleRed":"c-f_cZ"};